import { z } from 'zod';
import { categoryCvxSchema } from './menu/categorySchema';
import { menuItemCvxSchema } from './menu/menuItemSchema';
import { menuSchema } from './menu/menuSchema';
import { modifierGroupCvxSchema } from './menu/modifierGroupSchema';
import { modifierCvxSchema } from './menu/modifierSchema';

export const menuVersionSchema = z.object({
  ...menuSchema.shape,
  /**
   * Menu versions are a snapshot of a stored menu, that's why we use the `cvx` schemas.
   */
  categories: z.array(categoryCvxSchema),
  menuItems: z.array(menuItemCvxSchema),
  modifierGroups: z.array(modifierGroupCvxSchema),
  modifiers: z.array(modifierCvxSchema),

  /**
   * Maintain a reference to the original menu
   */
  menuId: z.string(),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
});
export type MenuVersion = z.output<typeof menuVersionSchema>;

export const menuVersionCvxSchema = menuVersionSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  updatedAt: z.number(),
});
export type MenuVersionCvx = z.output<typeof menuVersionCvxSchema>;
